import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Data } from "../Data";

const LegalWrapper = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  padding: 15vh 1rem;
  p:last-of-type {
    margin-bottom: 5rem;
  }
  p span {
    text-transform: lowercase;
  }
`;

const LegalTitle = styled.h1`
  font-weight: 700;
  margin-bottom: 1.5rem;
`;

const StyledLink = styled(Link)`
  &:hover {
    border-bottom: 1px solid white;
  }
`;

const Legal = () => {
  const data = Data;
  return (
    <LegalWrapper>
      <LegalTitle>Mentions Légales</LegalTitle>
      <p>
        Conformément aux dispositions des articles 6-III et 19 de la Loi
        n°2004-575 du 21 juin 2004 pour la Confiance dans l'économie numérique,
        dite L.C.E.N., il est porté à la connaissance des utilisateurs et
        visiteurs du site {data.companyName} les présentes mentions légales.
      </p>
      <p>
        Le site {data.websiteName} est accessible à l'adresse suivante :{" "}
        {data.websiteName}. L'accès et l'utilisation du site sont soumis aux
        présentes "Mentions légales" détaillées ci-après ainsi qu'aux lois et/ou
        règlements applicables.
      </p>
      <h3>Site</h3>
      <p>{data.websiteName}</p>
      <h3>Éditeur</h3>
      <p>
        L'entreprise {data.companyName}
        <br />
        située : {data.companyAdress} <br /> numéro SIRET : {data.companySiret}{" "}
        <br /> n° de téléphone : {data.companyPhone} <br /> adresse mail :{" "}
        <span>{data.companyEmail}</span>
      </p>
      <h3>Hébergeur</h3>
      <p>
        {data.websiteName} est hébergé par Vercel Inc., dont le siège social est
        situé 440 N Barranca Ave #4133 91723 Covina.
      </p>
      <StyledLink to="..">Retour à l'accueil</StyledLink>
    </LegalWrapper>
  );
};

export default Legal;
